import { create } from 'zustand';

interface ErrorState {
    success: string | null;
    error: string | null;
    setError: (message: string | null) => void;
    setSuccess: (message: string | null) => void;
    clearError: () => void;
}

export const useErrorStore = create<ErrorState>((set) => ({
    error: null,
    success: null,
    setError: (message: string | null) => set({ error: message }),
    setSuccess: (message: string | null) => set({ success: message }),
    clearError: () => set({ error: null }),
}));
